export default __webpack_public_path__ + "static/acl-vid-d81eaf3a663f22aab2e4d9205be87cdc.jpg";